import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KalturaUIModule } from '@kaltura-ng/kaltura-ui';
import { LocalizationModule } from '@kaltura-ng/mc-shared';
import { ReachFrameComponent } from './reach-frame.component';

@NgModule({
  imports: [CommonModule, KalturaUIModule, LocalizationModule],
  declarations: [ReachFrameComponent],
  exports: [ReachFrameComponent],
})
export class ReachFrameModule {}
